const routes = {
  login: 'login',
  guestExceptionReport:'boarding/exception-report',
  ipmGroup:'ipm/group',
  dashboard: 'dashboard',
  masterTemplates: 'masterTemplates',
  boardingSlots: 'boarding',
  results: 'results',
  yaBandRemainingGuests: 'ya-band-remaining-guests',
  stateroom: 'stateroom',
  guest: 'guest',
  boardingSlotHistoryReports: 'reports/boardingSlotHistory',
  locationHistoryReports: 'reports/locationHistory',
  sailorFlightDetailsReports: 'reports/sailor-flight-details-report',
  embarkDebarkPortUpdateReports: 'reports/embark-debark-port-updates',
  minorGuests: 'minor-guests',
  cancelledGuests: 'cancelled-guests',
  usGuests: 'us-guests',
  nonUsGuests: 'non-us-guests',
  guestsWithAlert: 'guests-with-alert',
  needAssistanceGuests: 'need-assistance-guests',
  unassignedStateroomGuests: 'unassigned-stateroom-guests',
  yaBandEligibleGuests: 'ya-band-eligible-guests',
  gangwayDashboard: 'gangway/dashboard',
  alertsAndMessages: 'alerts-and-messages',
  createAlerts: 'create/alerts',
  createMessage: 'create/messages',
  editAlert: 'edit/alert/:alertId',
  editMessage: 'edit/messages/:messageId',
  reports: 'reports',
  exceptionReports: 'reports/exception',
  locationReports: 'reports/location',
  movementReports: 'reports/movement',
  clearanceReports: 'reports/clearance',
  documentTypeBreakdownReport: 'reports/document-type-breakdown',
  sailorNationalityReport: 'reports/sailor-nationality',
  sailorAshoreVisitReport: 'reports/sailor-ashore-visits',
  genderDistributionByNationalityReport: 'reports/gender-distribution-nationality',
  inactiveVisitors: 'reports/inactive-visitors',
  boardingSlotReport: 'reports/boarding-slot',
  cbpReports: 'reports/cbp',
  ipmReports: 'reports/ipm',
  crew: 'crew',
  guests: 'guests',
  visitors: 'visitors',
  visitor: 'visitor',
  visitorDetail: 'visitor/:visitorId',
  alertDetail: 'alert/:alertId',
  messageDetail: 'message/:messageId',
  ipmLanding: 'ipm',
  fidelioReports: 'fidelio-reports',
  settings: 'settings',
  selectShip: 'select-ship',
  newReservation:'new-reservation',
  guestHistory:'guest-history',
  passengersWithAlertsReports: 'passengers-with-alerts-reports',
  onboardGuestWithPastDebarkDateReport: 'onboard-sailor-with-past-debark-date-report',
  portCoordinates: 'port-coordinates',
  portMasterData: 'port-coordinates/port-list',
  cbpDashboard: 'cbp-dashboard',
  cbpCompareEnoad: 'cbp-dashboard/compare-enoad',
  cbpMessageSchedule: 'cbp-dashboard/message-schedule',
  cbpVcoMessages: 'cbp-dashboard/vco-messages',
  crewRolesManagement: 'crew-roles-management',
  crewListingManagement: 'crew-roles-management/crew-listing',
  crewRolesMapping: 'crew-roles-management/role-mapping',
  crewRolesFeatureMapping: 'crew-roles-management/role-features',
  crewAddUser: 'crew-roles-management/add-user',
}

export default routes
